window.initSwiperWhenReadyAndVisible =
  window.initSwiperWhenReadyAndVisible ||
  function initSwiperWhenReadyAndVisible({
    element,
    init,
    threshold = 0.1,
    hiddenThreshold = null,
  }) {
    const run = () => {
      if (!window.swiperLoader) return;

      if (hiddenThreshold !== null && element.offsetParent === null) {
        const viewportHeight = window.innerHeight;
        window.swiperLoader.initWhenVisible(element, init, {
          rootMargin: `${viewportHeight}px`,
          threshold: hiddenThreshold,
        });
        return;
      }

      const isAboveFold = element.getBoundingClientRect().top < window.innerHeight;

      if (isAboveFold) {
        window.swiperLoader.initImmediately(init);
        return;
      }

      const viewportHeight = window.innerHeight;
      window.swiperLoader.initWhenVisible(element, init, {
        rootMargin: `${viewportHeight}px`,
        threshold,
      });
    };

    if (window.swiperLoader) {
      run();
      return null;
    }

    const onReady = () => run();
    window.addEventListener("swiperloader:ready", onReady, { once: true });
    return onReady;
  };

window.createSwiperReinitScheduler =
  window.createSwiperReinitScheduler ||
  function createSwiperReinitScheduler(callback, delay = 100) {
    let timeoutId = null;

    const schedule = (...args) => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }

      timeoutId = window.setTimeout(() => {
        timeoutId = null;
        callback(...args);
      }, delay);
    };

    schedule.cancel = () => {
      if (!timeoutId) return;
      clearTimeout(timeoutId);
      timeoutId = null;
    };

    return schedule;
  };
